<template>
  <div :style="brandColors" class="vehicle-unit-container">
    <div class="set-thumb-block">
      <div class="vehicle-thumb">
        <div class="vehicle-thumb-container">
          <a class="preview-images" href="#"
            ><img
              :alt="vehicle.modelName"
              class="img-responsive ls-is-cached lazyloaded vehicle-img"
              :src="vehicle.angleView"
          /></a>
        </div>
      </div>
    </div>
    <div class="vehicle-content">
      <div class="row">
        <div class="col-xs-12">
          <div class="vehicle-title">
            <a href="#" class="vehicle-link">
              <h4>{{ vehicle.modelName }}</h4>
            </a>
            <h5 class="text-center stock-number">Stock #123456</h5>
          </div>

          <div class="vehicle-price">
            <div class="row price-container">
              <div class="col-xs-12">
                <div class="prices-wrapper">
                  <div class="price-wrapper">
                    <h5 class="price-label">MSRP</h5>
                    <h3 class="price">${{ numberFormatter(price.market) }}</h3>
                  </div>
                  <div class="price-wrapper">
                    <h5 class="price-label">Our Price</h5>
                    <h3 class="price">
                      ${{
                        isLockedPricingSelected
                          ? "XX,XXX"
                          : numberFormatter(price.market - 1000)
                      }}
                    </h3>
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <div v-if="selectedPriceBtn && !usingFlatButton" class="get-price-btn-wrapper">
                  <img
                    class="get-price-btn"
                    :src="!hovering ? selectedPriceBtnImg : selectedPriceBtnHoverImg"
                    @mouseenter="hovering = true"
                    @mouseleave="hovering = false"
                  />
                </div>
              </div>
            </div>

            <div class="index-btns center-block">
              <a v-if="usingFlatButton" :class="brandButtonClass" class="get-price-flat-btn primary-btn" href="#">{{ flatButtonText }}</a>
              <a v-else class="btn-1" href="#" :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]">Value Your Trade</a>
              <a :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]" class="btn-2" href="#">Calculate Payments</a>
              <a :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]" class="btn-3" href="#">Notify Me If Price Drops</a>
              <a :class="[usingFlatButton || brand === 'cjdr' ? 'secondary-btn' : 'primary-btn', brandButtonClass]" class="btn-4" href="#">Get Pre-Approved</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numberWithCommas } from "@/helpers";

export default {
  name: "GridVehicle",
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
    priceBtnTitle: {
      type: String,
      required: true,
    },
    selectedPriceBtn: {
      type: [Object, null],
      required: false,
    },
    isLockedPricingSelected: {
      type: Boolean,
      required: true,
    },
    brandColors: {
      type: Object,
      required: true,
    },
    brand: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      hovering: false,
      largeBtnTypes: [
        "Locked Price Button",
        "Eprice Button",
        "Eprice Button Variant",
        "Additional Savings Button",
        "Schedule Test Drive Button",
      ],
    };
  },
  computed: {
    selectedPriceBtnImg() {
      return this.selectedPriceBtn.image;
    },
    selectedPriceBtnHoverImg() {
      if (this.selectedPriceBtn.hovered_image) {
        return this.selectedPriceBtn.hovered_image;
      } else {
        return this.selectedPriceBtn.image;
      }
    },
    usingFlatButton() {
      if (this.priceBtnTitle === 'Brand Specific HTML Button') {
        return true;
      } else {
        return false;
      }
    },
    flatButtonText() {
      if (this.isLockedPricingSelected) {
        return 'Click To Unlock Price';
      } else {
        return 'Click To Lock In Your EPrice';
      }
    },
    brandButtonClass() {
      if (this.brand.toLowerCase() !== 'none') {
        return this.brand.toLowerCase() + '-btn';
      } else {
        return 'default-btn';
      }
    }
  },
  methods: {
    numberFormatter(num) {
      return numberWithCommas(num);
    },
  },
};
</script>

<style
  scoped
  src="../../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
/*srp filter menu*/
.sort-menu-container .fa-check:before {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 17px;
}

.sort-menu-container .fa-plus:before {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 17px;
}

.sort-menu-container a.filter-button.section-heading {
  color: #333333 !important;
  font-size: 15px;
}

.sort-menu-container a.filter-button.section-heading.active i {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.sort-menu-container a.filter-button.section-heading.active i {
  transform: rotate(180deg);
}

.vehicles-found-container h1 {
  margin: 0 15px 0 0;
  display: inline-block;
  max-width: 50%;
  font-size: 18px;
}

.vehicles-found-container div {
  float: right;
  max-width: calc(50% - 15px);
  text-align: right;
}

@media (max-width: 991px) {
  .vehicles-found-container {
    padding: 15px !important;
    color: #ffffff;
    background-color: #000000;
  }

  .sort-menu-container {
    position: relative;
  }

  .row.vehicle-sort-menu > .col-md-3 > .text-center {
    text-align: center;
  }

  .listing-page .col-lg-12 {
    padding: 0px;
  }

  button#mobile-refine-results {
    color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
    border-color: rgba(0, 0, 0, 0.87);
    font-weight: 700;
    font-size: 10.5px;
    text-transform: uppercase;
  }

  button#mobile-refine-results:hover,
  button#mobile-refine-results:focus {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    outline: none;
  }

  .sort-menu-container button {
    color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
    font-weight: 700;
    max-width: 250px;
    margin: 10px auto;
    text-transform: uppercase;
  }

  .sort-menu-container button:hover,
  .sort-menu-container button:focus {
    color: #fff;
    background-color: rgba(0, 0, 0, 0.87);
    border-color: rgba(0, 0, 0, 0.87);
    outline: none;
  }

  .vehicle-filter-menu.hidden-sm.hidden-xs {
    display: block !important;
    height: 0;
  }
}

.stacked-srp-prices .single-stacked-price {
  margin-top: 0px;
}

.vehicle-unit-container {
  box-shadow: 2px 2px 5px rgb(47, 47, 47, 25%);
}

@media (min-width: 992px) {
  .vehicle-unit-container {
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }

  .vehicle-unit-container:hover {
    -webkit-transform: translateY(-5px);
    -ms-transform: translateY(-5px);
    transform: translateY(-5px);
    -webkit-box-shadow: 0 1px 30px rgb(47, 47, 47, 68%);
    box-shadow: 0 0px 30px rgb(47, 47, 47, 50%);
  }

  .vehicles-found-container h1 {
    flex-grow: 1;
    font-size: 18px;
    margin: 0 15px 0 0;
    font-weight: 400;
  }

  .sticky-side-menus {
    width: 100%;
  }

  .waitMe_container .waitMe {
    margin: 0 15px 0px 48px;
  }

  .filer-panel {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .listing-page > .row {
    position: relative;
  }

  .listing-page > .row:first-child {
    background-color: #eb0a1e;
    display: table;
    width: 100%;
    margin: 0;
  }

  .listing-page > .row:first-child::before,
  .listing-page > .row:first-child::after {
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000000;
  }

  body .vehicle-filter-menu .panel .panel-heading,
  body .vehicle-search-menu .panel .panel-heading {
    background-color: #000000;
  }

  .listing-page > .row:first-child::before {
    left: -100%;
  }

  .listing-page > .row:first-child::after {
    right: -100%;
  }

  .vehicle-sort-menu::before {
    display: block;
    position: absolute;
    top: 0;
    left: calc(10px - 5%);
    width: calc(220px + 5%);
    height: 100%;
  }

  .listing-page > .row:last-child {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .listing-page > .row:last-child::before {
    display: block;
    position: absolute;
    top: 0;
    left: calc(10px - 5%);
    width: calc(10px + 5%);
    height: 100%;
  }

  .row.vehicle-sort-menu + .row > div[class*="col-"] {
    display: inline-grid;
  }

  .row.vehicle-sort-menu + .row > div[class*="col-"]:first-child {
    width: 230px;
    padding-right: 0;
  }

  .row.vehicle-sort-menu + .row > div[class*="col-"]:last-child {
    width: calc(100% - 230px);
    padding-left: 48px;
  }

  .vehicle-filter-menu a.section-heading .selected-icon {
    float: right;
    color: #333333;
  }
}

/*not media queries*/
#sticky-menu-container {
  z-index: 99999998;
}

.listing-page {
  padding-top: 0;
}

.mobile-shortcut-btns {
  display: none !important;
}

.vehicles-found-container .vehicles-found {
  font-weight: bolder;
}

span.vehicles-found + span {
  font-weight: 400;
}

.vehicle-index-page a:hover,
.vehicle-index-page a:focus {
  text-decoration: none;
  outline: none;
}

.vehicle-index-page {
  position: relative;
  background: #f2f2f2;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -moz-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
}

.listing-page {
  background: transparent !important;
}

.listing-page .col-lg-12 {
  padding: 0;
}

.listing-page > .row:nth-child(2) {
  margin-top: 0;
}

.vehicles-found-container {
  padding: 15px 0;
  color: #fff;
  position: relative;
  z-index: 1;
  background: #000000;
}

#sortResultsDropdown {
  color: rgba(0, 0, 0, 0.87);
}

.vehicle-filter-menu .section-divider {
  border-bottom: none;
  min-height: 1px;
  clear: both;
  width: 100%;
  height: 1px;
}

/*sort results dropdown*/
.vehicle-sort-menu #sortResultsDropdown {
  color: black;
  font-weight: 500;
}

.vehicle-sort-menu #sortResultsDropdown:after {
  font-family: "Material Icons";
  content: "\e313";
  font-weight: bold;
  font-size: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

span.caret {
  display: none;
}

.vehicle-sort-menu .dropdown-menu {
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: unset;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}

.vehicle-sort-menu .dropdown-menu > li > a {
  color: rgba(0, 0, 0, 0.84);
  font-weight: 500;
  padding: 6px 12px;
}

.vehicle-sort-menu .dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-image: none;
  background-color: rgba(0, 0, 0, 0.04);
}

/*sort results dropdown*/

/*vehicle card style*/
.vehicle-toggle-btn {
  display: none;
}

.vehicle-index-summary span.pull-right {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
  font-weight: 500;
}

.vehicle-index-summary span {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}

.vdp-link {
  display: none;
}

/*vehicle price block*/
.stacked-srp-prices h3 {
  font-weight: 500;
  font-style: normal;
}

.price-container {
  padding: 0 25px 10px 25px;
}

.vehicle-price h3 {
  font-size: 18px;
}

.vehicle-price h5 {
  font-size: 14px;
}

.vehicle-price .locked-price h3 {
  width: 100%;
  margin: 0;
}

.row.stacked-srp-prices .col-xs-6:first-child {
  width: 100%;
  text-align: center;
}

.vehicle-price-block .vehicle-prices .col-xs-6 {
  width: 100%;
}

.price-wrapper {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

h5.price-label {
  text-transform: uppercase;
  font-weight: 600 !important;
  margin: 0;
  /* width: 100%; */
  float: none;
}

.price {
  margin: 0;
  /* width: 100%; */
  float: none;
}

.lowest-price h3 {
  font-weight: 600;
}

/*vehicle price block*/

/*vehicle card style*/

/*back to top*/

.section-heading[onclick="window.scrollTo(0, 0);"] {
  position: fixed;
  height: 56px;
  padding: 16px !important;
  width: 56px;
  right: 20px;
  bottom: 20px;
  border-radius: 50%;
  z-index: 99999999;
  background-color: #333;
  color: #fff !important;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.section-heading[onclick="window.scrollTo(0, 0);"] > span {
  display: none;
}

/*back to top*/

/*range filter*/

.vehicle-filter-menu .irs-bar {
  background: #00324f;
  border-color: #00324f;
}

/*range filter*/

/*srp sort dropdown*/
.vehicle-sort-menu {
  background-color: transparent;
  padding: 10px 0;
}

.vehicle-sort-menu .text-center {
  text-align: right;
}

#sortResultsDropdown {
  background-color: transparent;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}

/*srp grid view*/
#vehicles {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  padding-top: 3px;
}

.vehicle-unit-container {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 3px;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 6px);
  background-color: #fff;
  padding: 0px;
}

@media (max-width: 767px) {
  .vehicle-index-summary {
    padding-top: 65px;
  }

  #call-to-action-overlay {
    font-size: 35px;
  }
}

@media (min-width: 768px) {
  #vehicles > .vehicle-unit-container,
  .active-template-wrapper {
    width: calc(50% - 6px);
  }
}

@media (min-width: 1200px) {
  #vehicles > .vehicle-unit-container,
  .active-template-wrapper {
    width: calc(33.333% - 6px);
  }
}

@media (min-width: 1200px) {
  .vehicle-index-container {
    max-width: 1170px;
  }
}

@media (min-width: 1500px) {
  .vehicle-index-container {
    max-width: 1440px;
  }
}

@media (max-width: 991px) {
  .listing-page > .row:nth-child(3) > [class*="col-"]:first-child {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .listing-page > .row:nth-child(2) {
    height: fit-content;
    padding: 10px 15px 0px 15px;
  }
  .listing-page > .row:nth-child(3) > [class*="col-"]:first-child {
    padding: 0px 15px;
    text-align: center;
  }
  .listing-page > .row:nth-child(2) #mobile-refine-results,
  .listing-page > .row:nth-child(2) #sortResultsDropdown {
    margin: 0px 5px;
    padding: 10px;
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 0.3px;
    text-transform: capitalize;
    width: 130px;
    height: 37px;
  }
  .listing-page > .row:nth-child(2) #mobile-refine-results {
    background-color: #000000;
    color: #ffffff;
  }
  .listing-page > .row:nth-child(2) #sortResultsDropdown {
    background-color: #555555;
    color: #ffffff;
  }
  .vehicle-sort-menu #sortResultsDropdown:focus {
    outline: 0px;
  }
}

@media (min-width: 1200px) {
  .vehicle-index-page {
    padding: 0;
  }
}

.vehicle-bottom {
  margin-top: auto;
  padding: 0 10px;
}

.vehicle-index-container h4.special-title {
  text-align: center;
  padding-top: 5px;
}

.srp-special > .row:last-child {
  margin: 0;
  border-bottom: 1px dashed red;
}

.srp-special > .row:last-child > div[class*="col"] {
  padding: 0 0 5px;
}

.vehicle-badges {
  margin: 0 -5px;
}

.vehicle-badges > a {
  display: inline-block;
  width: calc(33.333% - 10px);
  margin: 0 5px;
}

div:not(.accordion-col) .vehicle-certification-badge {
  margin: auto 0;
  max-width: 100%;
  height: auto;
}

.infinite-paginate > .row {
  display: none;
}

/*srp sort dropdown*/
.vehicle-sort-menu {
  background-color: transparent;
  padding: 10px 0;
}

.vehicle-sort-menu .text-center {
  text-align: right;
}

#sortResultsDropdown {
  background-color: transparent;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}

/*srp grid view*/
#vehicles {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}

@media (max-width: 767px) {
  .vehicle-index-summary {
    padding-top: 65px;
  }
}

.vehicle-bottom {
  margin-top: auto;
  padding: 0 10px;
}

.vehicle-index-container h4.special-title {
  color: red;
  border-top: 1px dashed red;
  text-align: center;
  padding-top: 5px;
}

.srp-special > .row:last-child {
  margin: 0;
  border-bottom: 1px dashed red;
}

.srp-special > .row:last-child > div[class*="col"] {
  padding: 0 0 5px;
}

div:not(.accordion-col) .vehicle-certification-badge {
  margin: auto 0;
  max-width: 100%;
  height: auto;
}

.infinite-paginate > .row {
  display: none;
}

.vehicle-title h4 {
  margin-top: 12px;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.vehicle-title h4:hover {
  text-decoration: underline;
}

.vehicle-spex {
  text-align: center;
}

.vehicle-spex .strong {
  font-weight: 600;
}

.index-btns {
  padding: 0px 40px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.row.stacked-vehicle-prices,
.vehicle-price .row {
  margin: auto;
}

.vehicle-price {
  padding: 15px 0px 0px;
}

.new-false .vehicle-price {
  padding: 15px 0 0 0;
}

.vehicle-price .lowest-price h5 {
  margin-top: 5px !important;
}

.vehicle-spex .row {
  margin: auto;
}

.vehicle-spex .spex-box {
  padding: 5px;
  background: #f5f5f5;
  border-radius: 6px;
  margin: 10px auto;
}

.new-false .vehicle-price-block {
  padding-bottom: 0px;
}

.vehicle-price-block .highest-price {
  color: #333;
}

.vehicle-title {
  padding-right: 15px;
  padding-left: 15px;
}
.vehicle-thumb {
  text-align: center;
}
.index-btns a {
  text-align: center;
  text-decoration: none !important;
  margin: 5px auto;
  display: block;
  width: 100%;
  outline: none;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.vehicle-img {
  max-height: 210px;
  margin: 15px 0;
  padding: 0 15px;
}
.get-price-btn-wrapper {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.get-price-btn {
  cursor: pointer;
  max-width: 100%;
  max-height: 140px;
}
.prices-wrapper {
  text-align: center;
}
</style>